export default "__VITE_ASSET__DgT88KPm__"